import { SortableList } from '@thaddeusjiang/react-sortable-list'
import React from 'react'

function HeaderSorting({ sumInsuredData, headerList, setSortedHeads }) {
    console.log("headerList",headerList)
    return (
        <div>
            <SortableList
                items={headerList}
                setItems={setSortedHeads}
                itemRender={({ item }) => (
                    <div style={{ padding: '10px', border: '1px dashed rgb(87, 77, 77)', marginBottom: '5px', cursor: 'move' }} >
                        {item.sumInsuredHeader.title}
                    </div>
                )}
            />
        </div>
    )
}

export default HeaderSorting